<template>
  <div class="widget white_box">
    <div class="widget_header">
      <div class="location_tag">
        <h3 class="heading">
          New Backlinks
        </h3>
        <div class="sub_heading">
          Found in the last 30 days
        </div>
      </div>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/backlinks"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </button>
      </div>
    </div>
    <div
      v-if="!loading && backlinks.length > 0"
      class="table_wrapper"
    >
      <table class="table_component">
        <thead>
          <tr>
            <td style="width: 25%">
              <span>Domain Name</span>
            </td>
            <td style="width: 25%">
              <span>Domain Authority</span>
            </td>
            <td style="width: 25%">
              <span>No. of Backlinks</span>
            </td>
            <td style="width: 25%">
              <span>Date Found</span>
            </td>
          </tr>
        </thead>
      </table>

      <div class="table_body">
        <table class="table_component">
          <tbody>
            <tr
              v-for="(backlink, index) in backlinks"
              :key="index"
            >
              <td style="width: 25%">
                {{ backlink.domain }}
              </td>
              <td style="width: 25%">
                {{ backlink.score }}
              </td>
              <td style="width: 25%">
                {{ backlink.count }}
              </td>
              <td
                v-date="backlink.found"
                style="width: 25%"
              />
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      v-else
      class="loading_widget_data"
    >
      <div v-if="loading">
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>
      <div v-else>
        No new backlinks found
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      backlinks: [],
      loading: true
    }
  },
  computed: {
    ...mapState('dashboard', ['uuid', 'preview']),
  },
  mounted() {
    axios.post('/ajax/dashboard/get-widget-data', {
      type: 'newBacklinks',
      uuid: this.uuid
    }).then(response => {
      this.backlinks = response.data;
      this.loading = false;
    }).catch(error => {
      console.log(error);
    });
  },
}
</script>

<style scoped>
tr td:not(:first-of-type) {
  text-align: center;
}

.table_body {
  max-height: 252px;
  overflow-y: auto;
}
</style>
